import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AntdTable from "src/components/AntdTable/Table";
import { getUserRating } from "src/store/Slices/UsersRatingSlice";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";


const Rating = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const ratingsList = useSelector((state) => state.UsersRatingSlice?.ratings);
    const loading = useSelector((state) => state.UsersRatingSlice?.isLoading);

    // Преобразуем данные для таблицы
    const rows = ratingsList?.data?.value?.rows?.map((element) => {
        return {
            key: element?.key,
            id: element?.id,
            phoneNumber: element?.phoneNumber,
            fio: element?.fio || `${element?.clientF || ''} ${element?.clientI || ''} ${element?.clientO || ''}`.trim(),
            clubId: element?.clubId,
            club: element?.club,
            points: element?.points,
        };
    }) || [];

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    useEffect(() => {
        dispatch(getUserRating());
    }, [dispatch]);

    const filterOptionsArr = [
        { label: "Фильтрация", value: 0, index: undefined },
        { label: "По ID", value: 1, index: "id", title: "ID" },
        { label: "По номеру телефона", value: 2, index: "phoneNumber", title: "Номер телефона" },
        { label: "По ФИО", value: 3, index: "fio", title: "ФИО" },
        { label: "По клубу", value: 4, index: "club", title: "Клуб" },
        { label: "По баллам", value: 5, index: "points", title: "Баллы" },
    ];

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "points") {
                        formattedItems["pointsFrom"] = values[index][0];
                        formattedItems["pointsTo"] = values[index][1];
                    } else if (key === "phoneNumber") {
                        formattedItems["phoneNumber"] = values[index][0];
                    } else if (key === "fio") {
                        formattedItems["fio"] = values[index][0];
                    } else if (key === "club") {
                        formattedItems["club"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            getUserRating({
                flag: "get",
                value: {
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? false
                            : true
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        // Логика при клике на действие
        console.log("Клик по элементу:", element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            getUserRating({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            getUserRating({
                flag: "get",
                value: {
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    // Формируем объект с данными для AdminTable
    const columns = ratingsList?.data?.value?.columns.map((element) => {
        return {
            ...element
        }
    })

    return (
        <>
            {window.innerWidth >= 768 ? (
                <AntdTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={loading}
                    onClickRowOne={(record) => {
                        clickOnAction(record);
                    }}
                    columns={columns}
                    rows={rows}
                    total={ratingsList?.data?.value?.totalCount}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={columns}
                    elementsListLoading={loading}
                    setIsOpenAddEditModal={false}
                    setIsOpenDeleteModal={false}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    filterOptionsArr={filterOptionsArr}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Rating;